import React from 'react'
import { connect } from 'react-redux'
import * as actionCreator from '../../../redux/actions/data-action';
import connectCommon from '../../common/common-hoc';
import { Box } from '../../../third-party-components/material-ui';
import TaskInstruction from './instruction';

class RatingTaskInstruction extends React.Component {
    render() {
        const { previousLink, nextLink } = this.props;

        return (
            <TaskInstruction toPrevious={previousLink} toNext={nextLink}
                text={(
                    <Box>
                        <Box>
                            Please answer the questions
                        </Box>
                        <Box mt="1em">
                            Select answers honestly
                        </Box>
                    </Box>
                )} />
        )
    }
}

export default connect(null, actionCreator)(connectCommon(RatingTaskInstruction));